<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>

      <!-------------------------------------------------------------------->
      <!-- action -->
      <!-------------------------------------------------------------------->

    <el-row>
      <el-col :xs="12" :sm="12" :lg="12">
        <el-button class="ml-20" icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
      </el-col>
      
      <el-col class="mt-20" :xs="24" :sm="24" :lg="12" style="text-align: right">
        <el-popconfirm
            class="ml-10 popconfirm-bg"
            title="確定刪除所勾選的資料嗎?"
            confirm-button-text="確定"
            cancel-button-text="取消刪除"
            icon="el-iconf-info"
            icon-color="red"
            @confirm="handleBatchDelete()"
        >
          <el-button type="danger" slot="reference" class="mr-10">批次刪除 <i class="el-icon-delete"></i></el-button>
        </el-popconfirm>

        <el-button type="primary" @click.prevent="dialogImportFormVisible = true">匯入 <i class="el-icon-download"></i>
        </el-button>
        <el-button type="primary" @click.prevent="handleAdd" class="mr-20">新增 <i class="el-icon-circle-plus-outline"></i>
        </el-button>
      </el-col>
    </el-row>


      
    <el-row>  
      <el-col :xs="24" :sm="24" :lg="24">
        <el-col :xs="24" :sm="24" :lg="7">
          <el-main>
            <el-table :data="groupByTableData"
                      empty-text="無資料"
                      :default-expand-all="true"
                      header-row-class-name="headerStyle">
              <el-table-column label="產品系列" prop="name">
              </el-table-column>
              <el-table-column label="" type="expand">
                <template slot-scope="scope">
                  <div v-for="p in scope.row.children" :key="p.col" >
                      <el-button class="ml-20"  type="text" @click.prevent="searchTerm(p.col)"> {{p.col}} ({{p.count}})</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-col>

        <el-col :xs="24" :sm="24" :lg="17" class="mymain">  
          <el-main>
            <el-table id="product_table" :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle"
                    @selection-change="handleSelectChange">
              <el-table-column type="selection" width="35"></el-table-column>
              <el-table-column prop="name" label="名稱" width="200">
              </el-table-column>
              <el-table-column prop="model" label="型號" width="120">
              </el-table-column>
              <el-table-column prop="color" label="顏色" width="130">
              </el-table-column>
              <el-table-column prop="price" label="價格" width="100">
              </el-table-column>
              <el-table-column prop="notes" label="備註">
              </el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="warning" @click="handleEdit(scope.row)" circle> <i class="el-icon-edit"></i></el-button>
                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="handleDelete(scope.row.id)"
                  >
                    <el-button type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>

            <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="pageNum"
                  :page-size="pageSize"
                  :total="total"
                  @current-change="handleCurrentChange">
              </el-pagination>
            </div>

          </el-main>
        </el-col>
      </el-col>

      <!-------------------------------------------------------------------->
      <!-- dialog -->
      <!-------------------------------------------------------------------->
      <el-dialog title="商品資訊"
                 :visible.sync="dialogFormVisible"
                 width="50%"
                 @close="closeDialog">
        <el-form :model="form"
                 :rules="rules"
                 ref="dataForm"
                 label-width="100px">
          <el-form-item label="商品系列"">
            <el-select v-model="form.category" placeholder="選擇商品系列">
              <el-option v-for="cat in categories"
                         :key="cat.id"
                         :label="cat.value"
                         :value="cat.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名稱" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="商品型號" prop="model">
            <el-input v-model="form.model" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="顏色" prop="color">
            <el-input v-model="form.color" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="價格" prop="price">
            <el-input v-model="form.price" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="備註" prop="notes">
            <el-input v-model="form.notes" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveData('dataForm')">確 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="商品匯入"
                 :visible.sync="dialogImportFormVisible"
                 :width="dw">
        <el-form ref="importForm" label-width="100px">
          <div style="text-align: center;" v-if="loading">
            <i class="el-icon-loading" style="font-size:22px"></i>匯入處理中...
          </div>
          <el-upload drag
                     class="avatar-uploader"
                     :show-file-list="false"
                     :action="importAction"
                     :on-progress="avatarProgress"
                     :on-change="avatarChanged"
                     :on-success="handleImportSuccess"
                     :before-upload="beforeImport">
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">限上傳 xlsx、xls 格式</div>
          </el-upload>
        </el-form>
      </el-dialog>


      <el-drawer
        size="70%"
        title="搜尋"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">
        <div>
          <el-select :xs="24" v-model="queryField" placeholder="選擇搜尋條件" class="ml-10">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="keyword" style="width: 200px" placeholder="輸入關鍵字" class="ml-10 mt-10"
                    suffix-icon="el-icon-search"></el-input>

          <el-button type="primary" @click.prevent="search" class="ml-10 mt-10">查詢</el-button>
          <el-button type="normal" @click.prevent="clearQuery" class="ml-10 mt-10">清除條件</el-button>
        </div>
    
      </el-drawer>
    </el-row>    
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";

export default {
  name: "ProductMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      dw: '40%',

      drawer: false,
      direction: 'ltr',

      groupByTableData:[],
      loading: false,
      importAction: '',
      tableData: [],
      options: [{
        value: 'name',
        label: '依商品名稱'
      }, {
        value: 'model',
        label: '依商品型號'
      }],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 15,
      total: 0,
      dialogFormVisible: false,
      dialogImportFormVisible: false,
      formLabelWidth: '',
      multipleSelection:[],
      form: {
        name: '',
        model: '',
        color: '',
        price: '',
        category: ''
      },
      categories:[],
      roles: [],
      rules: {
        name: [{validator: checkName, trigger: 'change'}],
        model: [{validator: checkName, trigger: 'change'}],
        price: [{validator: checkName, trigger: 'change'}]
      }
    }
  },
  methods: {
    handleClose(){
      this.drawer = false
    },
    avatarProgress(){
      this.loading = true
    },
    avatarChanged(){
      this.loading = false
    },
    search() {
      this.drawer = false
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    clearQuery() {
      this.keyword = ''
      this.queryField = ''
      this.drawer = false
      this.loadData()
    },
    searchTerm(term){
      this.pageNum = 1
      this.total = 0
      this.queryField = 'name'
      this.keyword = term
      this.loadData()
      
      this.$nextTick(_ => {
        document.getElementById("product_table").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      });
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = '400'; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "40%"
      }
    },
    loadData() {
      let {pageNum, pageSize, queryField, keyword} = this
      let　url = `/product/page?pageNum=${pageNum}&pageSize=${pageSize}&queryField=${queryField}&keyword=${keyword}`

      try {

        this.request.get(url).then(res => {
          if (res.code === '200') {
             this.tableData = res.data.records
             this.total = res.data.total
          }
        })

      } catch (e) {
        this.tableData = []
        this.total = 0
        this.showResult('error', e.message)
      }

    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('product/saveProduct', this.form)

            this.showResult('success', '資料更新成功.')

            this.loadData()
            this.loadGroupbyData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
    },
    handleEdit(rowData) {
      //save current state
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        queryField: this.queryField,
        keyword: this.keyword
      }
      localStorage.setItem('LH_PRODUCT_PAGE_STATE', JSON.stringify(data))

      this.$router.push('/product/detail/' + rowData.id)
    },
    handleDelete(id) {

      this.request.delete("/product/"+id).then(res => {
        if (res.code === '200') {
           this.showResult('success', '資料刪除成功.')
           this.loadData()
           this.loadGroupbyData()
        } else {
           this.showResult('error', '資料刪除失敗.')
        }
      })
      
    },

    
    closeDialog() {
      this.$refs['dataForm'].resetFields()
      this.loadData()
    },
    exportData() {
      window.open(process.env.VUE_APP_API_SERVER + '/product/export', "new")
    },
    beforeImport(file) {
      console.log(file.type)
      const isExcel = (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel');
      if (!isExcel) {
        this.$message.error('限上傳 xlsx、xls 格式');
      }
      return isExcel
    },
    handleImportSuccess(res, file) {
      this.dialogImportFormVisible = false
      if (res.code === '200') {
        this.showResult('success', '匯入完成')
        this.loadData()
        this.loadGroupbyData()
      } else {
        this.showResult('error', res.message)
      }
    },

    loadGroupbyData() {
      this.request.get("/product/groupby").then(res => {
        if (res.code === '200') {
          this.groupByTableData = res.data
        }
      })
    },


    handleSelectChange(val){
      this.multipleSelection = val
    },
    handleBatchDelete(){
      let ids = this.multipleSelection.map( e => e.id)
      console.log(ids)

      this.request.post("/product/batch/del", ids).then(res => {
        if (res.code === '200') {
           this.showResult('success', '資料刪除成功.')
           this.loadData()
           this.loadGroupbyData()
        
        } else {
           this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    prepareProductCategory() {
      let req = '/dic/type?queryField=product_cat'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.categories = res.data
        }
      })
    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
  },
  mounted() {
    let cache = localStorage.getItem('LH_PRODUCT_PAGE_STATE')
    console.log('cache:', cache)
    let cacheObj = JSON.parse(cache)
    if (cache !== null) {
      this.pageNum = cacheObj.pageNum
      this.pageSize = cacheObj.pageSize
      this.queryField = cacheObj.queryField
      this.keyword = cacheObj.keyword
    }


    this.importAction = '/api/product/imp?token=' + this.userInfo.token
    this.loadData()
    this.loadGroupbyData()
    this.setDialogWidth()
    this.prepareProductCategory()
    
  }
}
</script>

<style scoped>
.el-5able {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 240px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 260px !important;
  border: 3px dashed #d9d9d9;
}


</style>
